import { TermsEffects } from './terms.effect';

export const effects: any[] = [TermsEffects];

export * from './terms.effect';
